import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Wrapper } from './styled';
import SharedTable from 'shared/ui/Table';
import { useIntl } from 'react-intl';
import EmptyAgents from '../Grid/components/EmptyAgents';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectIsFetching } from 'store/Agents/selectors';
import { selectIsAdmin } from 'store/Faraday/selectors';
import { changeStateAgent, setAgentsEntity, setOrderByUserAgents } from 'store/Agents/actions';
import selectModal from 'store/modals/selectors';
import { MODAL_AGENT_DETAIL } from 'store/modals/modals';
import { RUNNERS_ENTITY } from 'store/Agents/reducer';
import { selectIsFiltering } from 'store/Filters/selectors';
import agentsSchema from './schema';

const Table = ({ agents }) => {
  const dispatch = useDispatch();
  const [agentsList, setAgentsList] = useState(agents);
  const isFetching = useSelector(selectIsFetching);
  const isAdmin = useSelector(selectIsAdmin);
  const show = useSelector((state) => selectModal(state, MODAL_AGENT_DETAIL));
  const isFiltering = useSelector((state) => selectIsFiltering(RUNNERS_ENTITY, state));
  const intl = useIntl();

  useEffect(() => {
    setAgentsList(agents);
  }, [agents]);

  const fetchData = (sorted) => {
    if (!isFetching) {
      dispatch(setOrderByUserAgents(sorted));
    }
  };

  let noDataText = '';
  if (!isFetching) noDataText = isFiltering ? <NoSearchResults /> : <EmptyAgents />;

  useEffect(() => {
    dispatch(setAgentsEntity(RUNNERS_ENTITY));
  }, [dispatch]);

  return (
      <Wrapper>
        <SharedTable
          schema={ agentsSchema }
          context={ { isFetching, show, intl, isAdmin, onChangeState: (agent) => dispatch(changeStateAgent(agent)) } }
          data={ agentsList }
          isLoading={ isFetching }
          onFetch={ fetchData }
          noDataText={ noDataText }
        />
      </Wrapper>
  );
};

export default Table;
